export default __webpack_public_path__ + "static/media/bild04.b03800a3.webp";